<template>
  <b-card>
    <template #header>
      <span class="pull-left mt-2 mb-2"><strong>Mogelijke dagen voor Petty Cash levering (herhaalopdrachten)</strong></span>
      <b-button type="button" class="pull-right" variant="primary"
                v-can="'transportschema aanpassen'" v-if="!editable"
                @click="editable = true">
        Bewerken
      </b-button>
      <b-button type="button" class="pull-right" @click.prevent="updateData" variant="primary" v-can="'transportschema aanpassen'" v-if="editable">Opslaan</b-button>
    </template>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="12">
            <b-alert :show="feedback.show" :variant="feedback.variant" @dismissed="feedback.show=0" @dismiss-count-down="countDownChanged" dismissible>
              {{feedback.text}}
              <ul v-if="errors" class="mt-3">
                <li v-for="error in errors">{{error.toString()}}</li>
              </ul>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" v-can="'transportschema aanpassen'">
            <p>Stel hier de toegestane dagen in voor de herhaalopdrachten van deze locatie</p>
          </b-col>
          <b-col cols="12">
            <b-form-checkbox-group
              v-model="selected"
              switches
            >
            <b-list-group-item v-for="day in days" :key="`renewal-setting-${day.value}`">
              <b-row>
                <b-col cols="12" md="4" v-text="day.text" />
                <b-col cols="12" md="8">
                  <b-form-checkbox :value="day.value" switch :disabled="!editable" />
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row v-can="'transportschema aanpassen'" v-if="editable">
          <b-col cols="12">
            <hr>
            <b-button type="button" class="pull-right" @click.prevent="updateData" variant="primary">Opslaan</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { updateData, getData } from '../../api';

export default {
  name: 'recurring-setter',
  props: {
    settings: {
      type: Array,
      default: () => [],
    },
    create: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      all_settings: [],
      editable: this.create,
      selected: [],
      days: [
        {
          text: 'Maandag',
          value: "monday",
        },
        {
          text: 'Dinsdag',
          value: "tuesday"
        },
        {
          text: 'Woensdag',
          value: "wednesday"
        },
        {
          text: 'Donderdag',
          value: "thursday"
        },
        {
          text: 'Vrijdag',
          value: "friday"
        }
      ],
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      errors: null,
      saveButtonDisabled: false,
    }
  },
  methods: {
    async getData() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await getData(`locations/${this.$route.params.id}/recurring-settings`);
      if (request.status === 200) {
        this.saveButtonDisabled = false;
        this.editable = false;
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.saveButtonDisabled = false;
      }
    },
    async updateData() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const settings = this.all_settings.map(item => {
        return {
            ...item,
            start_date: item.start_date ? moment(item.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
        }
      });
      const request = await updateData(`locations/${this.$route.params.id}/recurring-settings`, {
        settings: this.selected,
      });
      if (request.status === 200) {
        this.feedback.show = true;
        this.feedback.text = 'Beschikbare dagen voor herhaalopdrachten zijn succesvol gewijzigd';
        this.feedback.variant = 'success';
        this.saveButtonDisabled = false;
        this.editable = false;
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.saveButtonDisabled = false;
      }
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },
    updateSettings(settings) {
      this.$set(this, 'all_settings', []);

      this.days.forEach((day) => {
        let obj = settings.find(x => x.day === day);

        if (!obj) {
          obj = {
            id: null,
            day: day,
            setting: null,
            start_date: null,
          }
        }

        this.all_settings.push(obj);
      });

      const selected  = this.settings.map(n => n.day);

      this.selected = selected;
    }
  },
  created() {
    this.updateSettings(this.settings);
  }
}

</script>
